import connector from "@/repository/connector";

function isFormDataPayload(payload) {
  return typeof FormData !== "undefined" && payload instanceof FormData;
}

function resolveConnector(payload) {
  return isFormDataPayload(payload) ? connector.connectorFormData : connector.connector;
}

export default {
  async getDonationSettings(username) {
    return connector.requestWithFallback(
      () => connector.connector.get(`page-settings/by_username/${username}/`),
    );
  },
  async updatePageSettings(id, payload) {
    if (!id) {
      throw new Error("ID настроек не найден");
    }
    return connector.requestWithFallback(
      () => resolveConnector(payload).put(`page-settings/${id}/`, payload),
    );
  },
  async updateDonationSettings(id, payload) {
    if (!id) {
      throw new Error("ID настроек не найден");
    }
    return connector.requestWithFallback(
      () => resolveConnector(payload).patch(`page-settings/${id}/`, payload),
    );
  },
  async listSpeechSynthesisVoices(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("speech-synthesis-voices/", { params }),
    );
  },
  async listAlertSounds(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("speech-synthesis-voices/", { params }),
    );
  },
  async getAlertSound(id) {
    return connector.requestWithFallback(
      () => connector.connector.get(`speech-synthesis-voices/${id}/`),
    );
  },
  async listAlertSettingGroups(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("alert-settings-groups/", { params }),
    );
  },
  async createAlertSettingGroup(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("alert-settings-groups/", payload),
    );
  },
  async importAlertSettingGroupFromDonationAlerts(payload) {
    return connector.requestWithFallback(
      () =>
        connector.connector.post("alert-settings-groups/import/", payload),
    );
  },
  async getAlertSettingGroup(id) {
    return connector.requestWithFallback(
      () => connector.connector.get(`alert-settings-groups/${id}/`),
    );
  },
  async replaceAlertSettingGroup(id, payload) {
    return connector.requestWithFallback(
      () => connector.connector.put(`alert-settings-groups/${id}/`, payload),
    );
  },
  async updateAlertSettingGroup(id, payload) {
    return connector.requestWithFallback(
      () => connector.connector.patch(`alert-settings-groups/${id}/`, payload),
    );
  },
  async removeAlertSettingGroup(id) {
    return connector.requestWithFallback(
      () => connector.connector.delete(`alert-settings-groups/${id}/`),
    );
  },
  async listAlertSettings(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("alert-settings/", { params }),
    );
  },
  async createAlertSetting(payload) {
    return connector.requestWithFallback(
      () => resolveConnector(payload).post("alert-settings/", payload),
    );
  },
  async getAlertSetting(id) {
    return connector.requestWithFallback(
      () => connector.connector.get(`alert-settings/${id}/`),
    );
  },
  async replaceAlertSetting(id, payload) {
    return connector.requestWithFallback(
      () => resolveConnector(payload).put(`alert-settings/${id}/`, payload),
    );
  },
  async updateAlertSetting(id, payload) {
    return connector.requestWithFallback(
      () => resolveConnector(payload).patch(`alert-settings/${id}/`, payload),
    );
  },
  async removeAlertSetting(id) {
    return connector.requestWithFallback(
      () => connector.connector.delete(`alert-settings/${id}/`),
    );
  },
  async listStatisticWidgetSettings(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("statistic-widget-settings/", { params }),
    );
  },
  async listModerationSettings(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("moderation-settings/", { params }),
    );
  },
  async updateModerationSetting(id, payload) {
    if (id == null || id === "") {
      throw new Error("ID настроек модерации не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.patch(`moderation-settings/${id}/`, payload),
    );
  },
  async getStatisticWidgetSettings(id) {
    if (!id) {
      throw new Error("ID виджета не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.get(`statistic-widget-settings/${id}/`),
    );
  },
  async createStatisticWidgetSettings(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("statistic-widget-settings/", payload),
    );
  },
  async updateStatisticWidgetSettings(id, payload) {
    if (!id) {
      throw new Error("ID виджета не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.patch(`statistic-widget-settings/${id}/`, payload),
    );
  },
  async deleteStatisticWidgetSettings(id) {
    if (!id) {
      throw new Error("ID виджета не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.delete(`statistic-widget-settings/${id}/`),
    );
  },
  async listWidgetVideoSettings(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("widget-video-settings/", { params }),
    );
  },
  async getWidgetVideoSettings(id) {
    if (!id) {
      throw new Error("ID настроек видео не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.get(`widget-video-settings/${id}/`),
    );
  },
  async updateWidgetVideoSettings(id, payload) {
    if (!id) {
      throw new Error("ID настроек видео не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.patch(`widget-video-settings/${id}/`, payload),
    );
  },
  async listWidgetVideos(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("widget-videos/", { params }),
    );
  },
  /**
   * Создание элемента собственного плейлиста.
   * Минимум: { url, order_number }.
   * Новый native-video pipeline может вернуть расширенный payload:
   * { source_url|url, media_url, poster_url, title, duration_seconds, status }.
   */
  async createWidgetVideo(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("widget-videos/", payload),
    );
  },
  async deleteWidgetVideo(id) {
    if (id == null || id === "") {
      throw new Error("ID видео не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.delete(`widget-videos/${id}/`),
    );
  },
  async deleteDonatorVideo(id) {
    if (id == null || id === "") {
      throw new Error("ID донатного видео не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.delete(`donator-videos/${id}/`),
    );
  },
  async cleanDonatorVideos() {
    return connector.requestWithFallback(
      () => connector.connector.delete("donator-videos/clean_videos/"),
    );
  },
  async listBanWords(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("ban-words/", { params }),
    );
  },
  /** Первая запись без id в GET: PUT на коллекцию (legacy). */
  async createBanWord(payload) {
    return connector.requestWithFallback(
      () => connector.connector.put("ban-words/", payload),
    );
  },
  async replaceBanWord(id, payload) {
    if (id == null || id === "") {
      throw new Error("ID записи не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.put(`ban-words/${id}/`, payload),
    );
  },
  async patchBanWord(id, payload) {
    if (id == null || id === "") {
      throw new Error("ID записи не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.patch(`ban-words/${id}/`, payload),
    );
  },
  async deleteBanWord(id) {
    if (id == null || id === "") {
      throw new Error("ID записи не найден");
    }
    return connector.requestWithFallback(
      () => connector.connector.delete(`ban-words/${id}/`),
    );
  },
};
